import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaHamburger, FaUtensils, FaConciergeBell, FaIceCream, FaBars } from "react-icons/fa";
import { FaCoffee } from "react-icons/fa";

const MenuIcon = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="3em"
    width="2em"
    xmlns="http://www.w3.org/2000/svg"
    style={{ verticalAlign: "middle", margin: "2px 10px", color: "#996e1e" }}
  >
    <path d="M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"></path>
  </svg>
);

const menus = {
  starters: {
    label: "Starters & Snacks",
    items: [
      {
        name: "Soups",
        desc: "Freshly prepared soups with rich flavors and aromatic spices.",
        img: "soup.jpg",
        subItems: [
          ["Tomato Soup", "Classic tangy tomato soup with fresh herbs.", "Tamato Soup.png"],
          ["Sweet Corn Soup", "Creamy sweet corn soup with a mild spicy kick.", "Sweet_corn_soup.png"],
          ["Hot & Sour Soup", "Indo-Chinese style hot and sour vegetable soup.", "Hot_sour.png"],
          ["Manchow Soup", "Thick Chinese soup topped with crispy noodles.", "Manchow_soup.png"],
        ],
      },
      {
        name: "Chaat & Snacks",
        desc: "Popular street-style chaat and crispy snacks bursting with taste.",
        img: "snack.jpg",
        subItems: [
          ["Pani Puri", "Crispy puris filled with spiced water and chutney.", "Panipuri.png"],
          ["Bhel Puri", "Puffed rice tossed with chutneys and sev.", "bhel_puri.png"],
          ["Sev Puri", "Flat puris topped with potato, onion, and chutneys.", "sev_puri.png"],
          ["Dahi Puri", "Puris filled with yogurt and sweet-spicy chutneys.", "dahi_puri.png"],
        ],
      },
      {
        name: "Chinese Starters",
        desc: "Indo-Chinese appetizers with bold sauces and crunchy textures.",
        img: "noodle.jpg",
        subItems: [
          ["Spring Rolls", "Crispy rolls filled with spiced vegetables.", "Thai Spring Roll.png"],
          ["Manchurian", "Deep-fried balls in spicy Manchurian gravy.", "manchuriyan.png"],
          ["Chilli Paneer", "Paneer tossed in spicy chilli garlic sauce.", "Paneer_chili.png"],
          ["Momos", "Steamed dumplings served with spicy dipping sauce.", "momos.png"],
        ],
      },
      {
        name: "Indian Starters",
        desc: "Classic Indian starters made with authentic spices and herbs.",
        img: "indian.jpg",
        subItems: [
          ["Samosa", "Crispy pastry filled with spiced potato and peas.", "Samosa.png"],
          ["Kachori", "Flaky fried pastry stuffed with lentil filling.", "Kachori.png"],
          ["Aloo Tikki", "Crispy potato patties served with green chutney.", "Aloo Tikki Chaat.png"],
          ["Paneer Tikka", "Marinated paneer cubes grilled in a tandoor.", "paneer_tikka.png"],
        ],
      },
      {
        name: "Italian Snacks",
        desc: "Cheesy, herby Italian bites with a modern twist.",
        img: "italian.jpg",
        subItems: [
          ["Garlic Bread", "Toasted bread with garlic butter and herbs.", "Garlic Bread.png"],
          ["Bruschetta", "Crispy bread topped with tomatoes and basil.", "bruschetta.png"],
          ["Cheese Balls", "Crispy fried balls with gooey melted cheese.", "Cheese Paneer Ball.png"],
          ["Mini Pizza", "Bite-sized pizzas with classic toppings.", "mini_pizza.png"],
        ],
      },
      {
        name: "South Indian Starters",
        desc: "Traditional South Indian snacks served with chutneys and sambar.",
        img: "south.jpg",
        subItems: [
          ["Medu Vada", "Crispy lentil donuts served with sambar.", "meduvada.png"],
          ["Idli", "Soft steamed rice cakes with coconut chutney.", "idli.png"],
          ["Rava Upma", "Semolina cooked with vegetables and spices.", "rava_upma.png"],
          ["Uttapam", "Thick rice pancake topped with onion and tomato.", "uttpam.png"],
        ],
      },
    ],
  },

  

  beverages: {
    label: "Beverages",
    items: [
      {
        name: "Welcome Drinks",
        desc: "Refreshing welcome beverages to start your celebration.",
        img: "3.jpg",
        subItems: [
          ["Fruits Punch Juice", "Raw mango drink with cumin and mint.", "Fruits Punch Juice.png"],
          ["Rose Sharbat", "Chilled rose-flavored sweet drink.", "Rosemilk.png"],
          ["strawberray", "Tangy spiced cumin water with mint.", "strawberray.png"],
          ["Shinkanji", "Fresh tender coconut water served chilled.", "Shikanji.png"],
        ],
      },
      {
        name: "Mocktails",
        desc: "Colorful non-alcoholic mocktails with fresh fruity flavors.",
        img: "6.jpg",
        subItems: [
          ["Virgin Mojito", "Mint lime soda with crushed ice.", "mojito.jpg"],
          ["Blue Lagoon", "Blue curacao syrup with lemon and soda.", "bluelagoon.jpg"],
          ["Watermelon Fizz", "Fresh watermelon blended with soda.", "watermelonfizz.jpg"],
          ["Strawberry Daiquiri", "Frozen strawberry mocktail blend.", "daiquiri.jpg"],
        ],
      },
      {
        name: "Fresh Juices",
        desc: "Freshly squeezed seasonal fruit juices, healthy and refreshing.",
        img: "5.jpg",
        subItems: [
          ["Orange Juice", "Freshly squeezed orange juice, pulpy and sweet.", "Orange_juice.png"],
          ["Watermelon Juice", "Chilled fresh watermelon juice.", "Jamfal Watermelon Juice.png"],
          ["Watermelon Greps Juice", "Blend of seasonal fruits.", "Watermelon Greps Juice.png"],
          ["Pineapple Juice", "Rich and tangy fresh pomegranate juice.", "Pineapple Juice.png"],
        ],
      },
      {
        name: "Buttermilk & Lassi",
        desc: "Traditional cooling drinks perfect for all occasions.",
        img: "2.jpg",
        subItems: [
          ["Sweet Lassi", "Chilled yogurt blended with sugar and cardamom.", "sweetlassi.jpg"],
          ["Salted Lassi", "Refreshing savory yogurt drink with cumin.", "saltedlassi.jpg"],
          ["Masala Chaas", "Spiced buttermilk with ginger and curry leaf.", "Buttermilk.png"],
          ["Mango Lassi", "Yogurt blended with fresh mango pulp.", "mangolassi.jpg"],
        ],
      },
      {
        name: "Hot Beverages",
        desc: "Tea, coffee, and hot drinks served fresh and aromatic.",
        img: "4.jpg",
        subItems: [
          ["Masala Chai", "Spiced Indian tea with ginger and cardamom.", "chai.jpg"],
          ["Filter Coffee", "South Indian decoction coffee with frothy milk.", "filtercoffee.jpg"],
          ["Lemon Tea", "Light tea with fresh lemon and honey.", "lemontea.jpg"],
          ["Green Tea", "Mild and healthy green tea served hot.", "greentea.jpg"],
        ],
      },
      {
        name: "Cold Soft Drinks",
        desc: "Chilled soft drinks to complement every meal.",
        img: "1.jpg",
        subItems: [
          ["Cola", "Classic chilled cola drinks.", "cococola.png"],
          ["Limca", "Refreshing lime-flavored carbonated drink.", "limca.jpg"],
          ["Sprite", "Crisp and clear lemon-lime soda.", "sprite.jpg"],
          ["Soda Water", "Plain chilled sparkling water.", "soda.jpg"],
        ],
      },
    ],
  },

 
  counters: {
    label: "Live Counters",
    items: [
      {
        name: "Chinese Live Counter",
        desc: "Live pani puri served fresh with flavorful water and fillings.",
        img: "Chinese Bhel.png",
        subItems: [
          ["Manchurian Dry", "Tangy spiced water with potato and chickpea filling.", "manchuriyan.png"],
          ["Manchurian Noodles", "Topped with yogurt and sweet tamarind chutney.", "Noodles.png"],
          ["Chinese Bhel", "Dry masala filling with chutneys.", "Chinese Bhel.png"],
          ["Potato Chilly Dry", "White peas curry stuffed in crispy puris.", "Aloochaat.png"],
        ],
      },
      {
        name: "South Indian Live Counter",
        desc: "Crispy dosas made live and served with chutneys and sambar.",
        img: "dosa.jpg",
        subItems: [
          ["Mini Dosa", "Spiced mashed vegetables with buttered pav.", "Mini Dosa.png"],
          ["Associated Dal Chilla", "Classic pav bhaji topped with melted cheese.", "Associated Dal Chilla.png"],
          ["Jodhpuri Dosa", "No onion no garlic version for Jain guests.", "Jodhpuri Dosa.png"],
          ["Idli Takatak", "Spicy Indo-Chinese twist on classic pav bhaji.", "idli.png"],
        ],
      },
      {
        name: "Chaat Live Counter",
        desc: "Assorted chaat items served fresh with tangy chutneys.",
        img: "chaat.jpg",
        subItems: [
          ["Bhel Puri", "Puffed rice tossed with onion, tomato, and chutneys.", "Bhel_puri.png"],
          ["Sev Puri", "Flat puris loaded with toppings and chutneys.", "sev_puri.png"],
          ["Papdi Chaat", "Crispy papdi with yogurt and chutneys.", "Papdi Chaat.png"],
          ["Aloo Chaat", "Fried potato cubes tossed in spicy masala.", "Aloochaat.png"],
        ],
      },
      {
        name: "Back Dish Live Counter",
        desc: "Crispy dosas made live and served with chutneys and sambar.",
        img: "Veg Back Dish.png",
        subItems: [
          ["Veg Back Dish", "Thin crispy plain dosa with coconut chutney.", "Veg Back Dish.png"],
          ["Pineapple Macaroni Back Dish", "Dosa stuffed with spiced potato filling.", "Pineapple Macaroni Back Dish.png"],
          ["Mix Pasta Back Dish", "Loaded with cheese and served hot.", "Mix Pasta Back Dish.png"],
          ["Cheese Lazania Back Dish", "Dosa spread with spicy red chutney inside.", "Cheese Lazania Back Dish.png"],
        ],
      },
      {
        name: "Tandoor / Kebab Live Counter",
        desc: "Live tandoori kebabs grilled with authentic spices.",
        img: "tandoori.jpg",
        subItems: [
          ["Paneer Tikka", "Marinated paneer cubes grilled in tandoor.", "paneer_tikka.png"],
          ["Hara Bhara Kebab", "Spinach and pea kebabs with mint chutney.", "Kabab.png"],
          ["Cheese Paneer Ball", "Whole wheat bread baked fresh in tandoor.", "Cheese Paneer Ball.png"],
          ["Paneer Chilla", "Spiced minced vegetable kebabs on skewers.", "Paneer Chilla.png"],
        ],
      },
      {
        name: "Premium Live Counter",
        desc: "Live pasta and noodles cooked with custom sauces.",
        img: "noodles.jpg",
        subItems: [
          ["Mini Coin Pizza", "Stir-fried noodles with veggies in soy sauce.", "mini_pizza.png"],
          ["Mexican Tacos", "Spicy noodles tossed in schezwan sauce.", "Mexican Tacos.png"],
          ["Bruseto", "Pasta in spicy tomato sauce.", "Bruseto.png"],
          ["Waffle Dosa", "Creamy béchamel sauce pasta with herbs.", "Waffle Dosa.png"],
        ],
      },
    ],
  },
  main: {
    label: "Main Course",
    items: [
      {
        name: "Gujarati Cuisine",
        desc: "Traditional Gujarati dishes with balanced sweet and savory flavors.",
        img: "dish1.png",
        subItems: [
          ["Dal Dhokli", "Wheat noodles cooked in spiced lentil soup.", "dhokali shaak.png"],
          ["Bharela Raviya", "Mixed vegetable curry with fenugreek dumplings.", "Bharela Raviya.png"],
          ["Lila Chana nu Shak", "Strained yogurt dessert with saffron.", "Lila Chana nu Shak.png"],
          ["Gujarati Kadhi", "Sweet-tangy yogurt curry with pakoras.", "Gujarati Kadhi.png"],
        ],
      },
      {
        name: "Punjabi Cuisine",
        desc: "Rich, creamy Punjabi dishes prepared with bold spices.",
        img: "dish2.png",
        subItems: [
          ["Dal Makhani", "Slow-cooked black lentils in creamy tomato base.", "dal_makhni.png"],
          ["Paneer Butter Masala", "Paneer in rich buttery tomato gravy.", "Paneer Butter Cheese Masala.png"],
          ["Chole Sabji", "Spiced chickpeas with fluffy fried bread.", "Chhole_sabji.png"],
          ["Paneer Lakhanvi", "Mustard greens with makki roti.", "Paneer Lakhanvi.png"],
        ],
      },
      {
        name: "Rajasthani Cuisine",
        desc: "Royal Rajasthani recipes featuring authentic desert flavors.",
        img: "dish3.png",
        subItems: [
          ["Dal Baati Churma", "Baked wheat balls with lentil soup and churma.", "dal-bati.png"],
          ["Gatte ki Sabzi", "Gram flour dumplings in spicy yogurt curry.", "Besan Gatta Shak.png"],
          ["Ker Sangri", "Desert beans and berries cooked with spices.", "ker.png"],
          ["Bajre ki Roti", "Pearl millet flatbread with ghee.", "bajra_rotla.png"],
        ],
      },
      {
        name: "South Indian Cuisine",
        desc: "Authentic South Indian meals served with rice and curries.",
        img: "dosa.jpg",
        subItems: [
          ["Sambar Rice", "Rice mixed with lentil vegetable soup.", "sambhar_pulao.png"],
          ["Rasam", "Thin spiced tomato pepper soup.", "rasam.png"],
          ["Coconut Rice", "Rice cooked with coconut and curry leaves.", "coconut_pulao.png"],
          ["Avial", "Mixed vegetables in coconut yogurt gravy.", "avial.png"],
        ],
      },
      {
        name: "North Indian Specialties",
        desc: "Classic North Indian dishes cooked with traditional spices.",
        img: "North_indian.jpg",
        subItems: [
          ["Shahi Paneer", "Paneer in rich cashew and cream gravy.", "Shahi Paneer.png"],
          ["Matar Paneer", "Green peas and paneer in tomato onion gravy.", "matarpaneer.png"],
          ["Jeera Rice", "Basmati rice tempered with cumin seeds.", "Jeerarice.png"],
          ["Biryani", "Aromatic layered rice with spiced vegetables.", "Biryani.png"],
        ],
      },
      {
        name: "Modern Indian",
        desc: "Contemporary Indian cuisine with innovative flavors and presentation.",
        img: "modern_indian.jpg",
        subItems: [
          ["Quinoa Pulao", "Healthy quinoa cooked with Indian spices.", "qui pulao.png"],
          ["Fusion Thali", "Mini portions of modern and classic dishes.", "Thali.png"],
          ["Tandoori Stuffed Capsicum", "Bell peppers stuffed with spiced filling.", "tandoori capsicum.png"],
          ["Jackfruit Curry", "Raw jackfruit in rich masala curry.", "jackfruit curry.png"],
        ],
      },
    ],
  },



  desserts: {
    label: "Desserts",
    items: [
      {
        name: "Regular Dessert",
        desc: "Soft milk dumplings soaked in fragrant sugar syrup.",
        img: "gulabjamun.jpg",
        subItems: [
          ["Mohan Thal", "Traditional soft jamuns in sugar syrup.", "Mohanthal.png"],
          ["Gulab-jambun", "Dark-fried jamuns with a caramelized outer crust.", "Gulabjamun.png"],
          ["Topara Pak", "Bite-sized jamuns in saffron syrup.", "Topara Pak.png"],
          ["Churmana Ladoo", "Jamuns filled with khoya and dry fruits.", "ladvo.png"],
        ],
      },
    
      {
        name: "Premium Desserts",
        desc: "Creamy assorted ice creams in classic and premium flavors.",
        img: "Golden Cruse Basundi.png",
        subItems: [
          ["Anjeer Vedhami", "Classic creamy vanilla bean ice cream.", "Anjeer Vedhami.png"],
          ["Badam Akharot Halwo", "Rich fresh mango flavored ice cream.", "Badam Akharot Halwo.png"],
          ["Dry Fruits Halwo", "Dark chocolate fudge ice cream.", "Dry Fruits Halwo.png"],
          ["Panch Ratna Halwo", "Traditional Indian frozen dessert with cardamom.", "Panch Ratna Halwo.png"],
        ],
      },
      {
        name: "Liquid Desserts",
        desc: "Rich chocolate brownie served soft and indulgent.",
        img: "rasmalai.jpg",
        subItems: [
          ["kheer", "Fudgy dark chocolate brownie square.", "kheer.png"],
          ["Doodh-Pak", "Warm brownie topped with vanilla scoop.", "Doodh-Pak.png"],
          ["Fruits Salad", "Chocolate brownie loaded with walnuts.", "Fruitsalad.png"],
          ["Kesariya Doodh", "Vanilla caramel version of the classic brownie.", "kesar_dudh.png"],
        ],
      },
      {
        name: "Traditional Indian Sweets",
        desc: "Fresh seasonal fruits mixed with smooth vanilla custard.",
        img: "fruitsalad.jpg",
        subItems: [
          ["Classic Fruit Custard", "Mixed fruits in smooth vanilla custard.", "Fruitsalad.png"],
          ["cremy_salad", "Custard loaded with fresh mango pieces.", "cremy_salad.png"],
          ["Sheekhand", "Berry-topped creamy custard.", "Sheekhand.png"],
          ["Almod_icecream", "Fresh seasonal cut fruits served chilled.", "Almod_icecream.png"],
        ],
      },
      {
        name: "Live Dessert Counters",
        desc: "Soft paneer discs soaked in saffron-flavored milk.",
        img: "icecream.jpg",
        subItems: [
          ["Strawberray Ice Cream", "Soft discs in saffron milk with pistachios.", "Strawberry_icecream.png"],
          ["Kesar Pista", "Rose-flavored milk with delicate discs.", "Kesar_pista.png"],
          ["Rajbhog_icecream", "Cream-stuffed Bengali sweet in sugar syrup.", "Rajbhog_icecream.png"],
          ["Cookie_icecream", "Large saffron-stuffed rasgulla variant.", "Cookie_icecream.png"],
        ],
      },
      {
        name: "International Desserts",
        desc: "Traditional slow-cooked thickened milk dessert.",
        img: "Badam Katli.png",
        subItems: [
          ["Kalazam Anjeer Draksh Barfi", "Thickened milk sweetened with cardamom.", "Kalazam Anjeer Draksh Barfi.png"],
          ["Khajoor Vedhami", "Fried sweet pancakes topped with rabri.", "Khajoor Vedhami.png"],
          ["Jalebi Rabri", "Crispy jalebis served with cold rabri.", "Jalebi (2).png"],
          ["Rasmalai", "Kulfi topped with chilled rabri.", "Rasmalai.png"],
        ],
      },
    ],
  },
};

const FoodMenuSection = () => {
  const [activeTab, setActiveTab] = useState("starters");
  const [selectedItem, setSelectedItem] = useState(null);

  const tabs = [
    { key: "starters", icon: <FaHamburger size={22} /> },
    { key: "beverages", icon: <FaCoffee size={22} /> },
    { key: "counters", icon: <FaConciergeBell size={22} /> },
    { key: "main", icon: <FaUtensils size={22} /> },
    { key: "desserts", icon: <FaIceCream size={22} /> },
  ];

  const handleTabChange = (key) => {
    setActiveTab(key);
    setSelectedItem(null);
  };

  const currentItems = menus[activeTab].items;

  return (
    <section className="food-menu-section fix section-padding bg-color2">

      <div className="marquee-wrapper style-1 text-slider section-padding pt-0">
        <div className="marquee-inner to-left">
          <ul className="marqee-list d-flex">
            <li className="marquee-item style1">
              <span className="text-slider"></span>
              <span className="text-slider text-style">PREMIUM CATERING EXPERIENCE</span>
              <span className="text-slider"></span>
              <span className="text-slider text-style">LIVE FOOD COUNTERS</span>
              <span className="text-slider"></span>
              <span className="text-slider text-style">CUSTOMIZED EVENT MENUS</span>
              <span className="text-slider"></span>
              <span className="text-slider text-style">ROYAL FOOD PRESENTATION</span>
              <span className="text-slider"></span>
              <span className="text-slider text-style">WEDDINGS & AUSPICIOUS EVENTS</span>
              <span className="text-slider"></span>
              <span className="text-slider text-style">FRESH INGREDIENTS, FLAWLESS TASTE</span>
              <span className="text-slider"></span>
              <span className="text-slider text-style">ELEGANT BUFFET & SERVICE</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="food-menu-wrapper mt-5 style1">
        <div className="container">
          <div className="food-menu-tab-wrapper style-bg">

            <div className="title-area text-center">
              <MenuIcon />
              <h2 className="title" style={{ display: "inline-block", margin: "0 10px" }}>
                Spice Root Menu 
              </h2>
              <MenuIcon />
            </div>

            {/* TABS */}
            <div className="food-menu-tab">
              <ul className="nav nav-pills mb-3 food-menu-tabs flex-nowrap justify-content-between w-100">
                {tabs.map((tab) => (
                  <li className="nav-item" key={tab.key}>
                    <button
                      className={`nav-link d-flex align-items-center gap-2 ${activeTab === tab.key ? "active" : ""}`}
                      onClick={() => handleTabChange(tab.key)}
                    >
                      {tab.icon}
                      {menus[tab.key].label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* BACK BUTTON when sub-items are shown */}
            {selectedItem !== null && (
              <div className="mb-3">
                <button
                  onClick={() => setSelectedItem(null)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#e53935",
                    fontWeight: 600,
                    fontSize: "15px",
                    cursor: "pointer",
                    padding: "6px 0",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  ← Back to {menus[activeTab].label}
                </button>
                <h5 style={{ fontWeight: 700, marginTop: "6px" }}>
                  {currentItems[selectedItem].name}
                </h5>
                <p style={{ color: "#777", fontSize: "14px", marginBottom: "16px" }}>
                  {currentItems[selectedItem].desc}
                </p>
              </div>
            )}

            {/* MAIN ITEMS GRID */}
            {selectedItem === null && (
              <div className="row gx-3 gy-3">
                {currentItems.map((item, i) => (
                  <div className="col-12 col-md-6" key={i}>
                    <div
                      className="single-menu-items"
                      onClick={() => setSelectedItem(i)}
                      style={{ cursor: "pointer", transition: "box-shadow 0.2s" }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.boxShadow = "0 4px 18px rgba(0,0,0,0.12)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.boxShadow = "none")
                      }
                    >
                      <div className="details">
                        <div className="menu-item-thumb">
                          <img
                            className="rounded-circle"
                            src={`assets/img/menu/${item.img}`}
                            alt={item.name}
                          />
                        </div>
                        <div className="menu-content">
                          <h3 style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            {item.name}
                            <span style={{ fontSize: "18px", color: "#e53935", marginLeft: "8px" }}>›</span>
                          </h3>
                          <p>{item.desc}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* SUB-ITEMS GRID */}
            {selectedItem !== null && (
              <div className="row gx-3 gy-3">
                {currentItems[selectedItem].subItems.map((sub, i) => (
                  <div className="col-12 col-md-6" key={i}>
                    <div className="single-menu-items">
                      <div className="details">
                        <div className="menu-item-thumb">
                          <img
                            className="rounded-circle"
                            src={`assets/img/customize/${sub[2]}`}
                            alt={sub[0]}
                          />
                        </div>
                        <div className="menu-content">
                          <Link to="/menu">
                            <h3>{sub[0]}</h3>
                          </Link>
                          <p>{sub[1]}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

          </div>
          <div className="btn-wrapper mt-30" >
            <a className="theme-btn" href="/build-menu">
              VIEW MAIN MENU <i className="fa-sharp fa-regular fa-arrow-right"></i>
            </a>
          </div>
          <img className="animation" alt="shape" src="assets/img/shape/shape1.png" />
        </div>
      </div>
    </section>
  );
};

export default FoodMenuSection;